// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__lA2v2","fileBtn":"File_fileBtn__3QuXl","closeBtn":"File_closeBtn__39NDF","fileSelected":"File_fileSelected__3gbVN","disabled":"File_disabled__1KoWK"};